<template>
  <div class="loader">
    <div class="loader__progress" :style="{ width: `${progress}%` }"></div>
  </div>
</template>

<script setup lang="ts">
const progress = ref(0)

const interval = ref<NodeJS.Timeout>()

onMounted(() => {
  interval.value = setInterval(() => {
    if (progress.value === 100) {
      progress.value = 0
    } else {
      progress.value += 1
    }
  }, 15)
})

onUnmounted(() => {
  clearInterval(interval.value)
})
</script>

<style scoped lang="scss">
@use '@/styles/variables.scss' as *;

.loader {
  height: 4px;
  width: 100%;
  background: $black-10;
  border-radius: 9999px;
  overflow: hidden;

  &__progress {
    height: 100%;
    background: $gold-primary-100;
  }
}
</style>
